import { Injectable } from '@angular/core'
import { SocialShareType } from 'src/app/interfaces/main'
import { LogService } from '../log.service'
import { SimpleSoulmateLogEvent } from 'src/app/interfaces/log/simple-soulmate-log'
import { Gender } from 'src/app/interfaces/user'

@Injectable({
  providedIn: 'root',
})
export class SimpleSoulmateLogService {
  constructor(private logService: LogService) {}
  // [맛 소울메이트 랜딩] 화면 진입
  logLandingScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LANDING_SCREEN_VIEWED)
  }

  // [맛 소울메이트 랜딩] 시작 버튼 클릭
  logLandingStartButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LANDING_START_BUTTON_CLICKED)
  }

  // [맛 소울메이트 랜딩] MBTI 버튼 클릭
  logLandingMbtiButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LANDING_MBTI_BUTTON_CLICKED)
  }

  // [맛 소울메이트 메인] 화면 진입
  logMainScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_MAIN_SCREEN_VIEWED)
  }

  // [맛 소울메이트 메인] 룰렛 클릭
  logMainRouletteButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_MAIN_ROULETTE_BUTTON_CLICKED)
  }

  // [맛 소울메이트 메인] 공유 버튼 클릭
  logMainShareButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_MAIN_SHARE_BUTTON_CLICKED)
  }

  // [맛 소울메이트 메인] 앱 버튼 클릭
  logMainAppButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_MAIN_APP_BUTTON_CLICKED)
  }

  // [맛 소울메이트 만들기] 화면 진입
  logCreateScreenViewed(step: 'gender' | 'mbti' | 'gender-preference' | 'mbti-preference'): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_CREATE_SCREEN_VIEWED, { step })
  }

  // [맛 소울메이트 만들기] 완료 버튼 클릭
  logCreateSubmitButtonClicked(step: 'gender' | 'mbti' | 'gender-preference' | 'mbti-preference'): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_CREATE_SUBMIT_BUTTON_CLICKED)
  }

  // [맛 소울메이트 로딩] 화면 진입
  logLoadingScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LOADING_SCREEN_VIEWED)
  }

  // [맛 소울메이트 로딩] 펜딩 결과 화면 노출
  logLoadingPendingResultViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LOADING_PENDING_RESULT_VIEWED)
  }

  // [맛 소울메이트 로딩] 쿠팡 버튼 클릭
  logLoadingAdButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_LOADING_AD_BUTTON_CLICKED)
  }

  // [맛 소울메이트 결과] 화면 진입
  logResultScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RESULT_SCREEN_VIEWED)
  }

  // [맛 소울메이트 결과] 모든 순위 보기 클릭
  logResultShowAllRankClicked(type: 'self' | 'idealType'): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RESULT_SHOW_ALL_RANK_CLICKED, { type })
  }

  // [맛 소울메이트 결과] 성별 별 순위 보기 클릭
  logResultGenderRankButtonClicked(type: 'self' | 'idealType'): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RESULT_GENDER_RANK_BUTTON_CLICKED, { type })
  }

  // [맛 소울메이트 결과] 공유 버튼 클릭
  logResultShareButtonClicked(type: SocialShareType): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RESULT_SHARE_BUTTON_CLICKED, { type })
  }

  // [맛 소울메이트 결과] 플로팅 버튼 클릭
  logResultFloatingButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RESULT_FLOATING_BUTTON_CLICKED)
  }

  // [맛 소울메이트 랭킹] 화면 진입
  logRankScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_SCREEN_VIEWED)
  }

  // [맛 소울메이트 랭킹] 모두 보기 클릭
  logRankShowAllButtonClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_SHOW_ALL_BUTTON_CLICKED)
  }

  // [맛 소울메이트 랭킹] MBTI 별 순위 보기 클릭
  logRankMbtiButtonClicked(gender: Gender): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_MBTI_BUTTON_CLICKED, { gender })
  }

  // [맛 소울메이트 랭킹 MBTI 선택] 화면 진입
  logRankMbtiSelectScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_MBTI_SELECT_SCREEN_VIEWED)
  }

  // [맛 소울메이트 랭킹 MBTI 선택] MBTI 클릭
  logRankMbtiSelectClicked(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_MBTI_SELECT_CLICKED)
  }

  // [맛 소울메이트 랭킹 MBTI 결과] 화면 진입
  logRankMbtiResultScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_MBTI_RESULT_SCREEN_VIEWED)
  }

  // [맛 소울메이트 랭킹 MBTI 결과] 공유 버튼 클릭
  logRankMbtiResultShareButtonClicked(type: SocialShareType): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SIMPLE_SOULMATE_RANK_MBTI_RESULT_SHARE_BUTTON_CLICKED, { type })
  }

  logSoulmateLandingScreenViewed(): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SOULMATE_LANDING_SCREEN_VIEWED)
  }

  logSoulmateLandingShareButtonClicked(type: SocialShareType): void {
    this.logService.eventLogging(SimpleSoulmateLogEvent.SOULMATE_LANDING_SHARE_BUTTON_CLICKED, { type })
  }
}
